import React, { Component } from 'react';
import NewsItem from './NewsItem';
import PropTypes from 'prop-types';

export default class News extends Component {

    static defaultProps = {
        country: 'us',
        pageSize: 8,
        category: "general"
    };


  
   static propTypes = {
        country: PropTypes.string,
        pageSize: PropTypes.number,
        category: PropTypes.string,
        setProgress: PropTypes.func.isRequired
    };

    state = {
        articles: [],
        loading: false,
        page: 1,
        totalResults: 0
    };

    async updateNews() {
        this.props.setProgress(0);
        let url = `https://newsapi.org/v2/top-headlines?country=${this.props.country}&category=${this.props.category}&apiKey=1039b46c20e74e4bac22af9c00223caf&page=${this.state.page}&pageSize=${this.props.pageSize}`;
        let data = await fetch(url);
        this.props.setProgress(20);
        let parsedData = await data.json();
        this.props.setProgress(60);
        this.setState({
            articles: parsedData.articles,
            totalResults: parsedData.totalResults,
            loading: false
        });
        this.props.setProgress(100);
    }

    async componentDidMount() {
        this.updateNews();
    }

    handlePreviousClick = () => {
        this.setState(
            (prevState) => ({ page: prevState.page - 1 }),
            this.updateNews
        );
    }

    handleNextClick = () => {
        this.setState(
            (prevState) => ({ page: prevState.page + 1 }),
            this.updateNews
        );
    }

    fetchMoreData = async () => {
        this.setState(
            (prevState) => ({ page: prevState.page + 1 }),
            this.updateNews
        );
    }

    render() {
        const { articles, page, totalResults } = this.state;
        return (
            <>
                <div className="container my-4">
                    <h2 className='text-center' style={{ margin: '35px 0px', marginTop: '90px' }}>
                        NewsApp - Top Headlines
                    </h2>

                    <div className='container'>
                        <div className="row">
                            {articles.map((element) => (
                                <div className="col-md-4" key={element.url}>
                                    <NewsItem
                                        title={element.title || ""}
                                        description={element.description || ""}
                                        imageUrl={element.urlToImage}
                                        newsUrl={element.url}
                                        author={element.author}
                                        date={element.publishedAt}
                                        source={element.source.name}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
         
             { /*  <InfiniteScroll
                        dataLength={articles.length}
                        next={this.fetchMoreData}
                        hasMore={articles !== totalResults}
                        loader={<h4>Loading...</h4>}    />
                        */}
                <div className='container d-flex justify-content-between my-4'>
                    <button
                        disabled={page <= 1}
                        type="button"
                        className="btn btn-secondary"
                        onClick={this.handlePreviousClick}
                    >
                        &larr; Previous
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={this.handleNextClick}
                    >
                        Next &rarr;
                    </button>
                </div>
            </>
        );
    }
}
